<template>
    <div class="row align-items-center">
        <div
            :class="'col-md-' + cols"
            v-for="(element, index) in elements"
            :key="index"
        >
            <div class="remove-button" @click="removeElement(index)">
                <i class="fa fa-times"></i>
            </div>
            <input type="text" class="form-control" v-model="element.title" />
        </div>
        <div class="text-right" :class="'col-md-' + cols">
            <a href="#" class="blue-link" @click.prevent="addElement"
                ><i class="fa fa-plus"></i> ADD NEW</a
            >
        </div>
    </div>
</template>

<script>
export default {
    watch: {
        elements: {
            deep: true,
            handler: function(newVal, oldVal) {
                this.$emit("input", newVal.map(element => {
                    return element.title;
                }));
            }
        }
    },
    props: {
        maxItems: {
            type: Number,
            default: 10
        },
        cols: {
            type: Number,
            default: 3
        },
        items: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            elements: [{ title: "" }],
        };
    },
    mounted() {
        if (this.items.length) {
            this.elements = this.items.map(item => ({ title: item }));
        }
    },
    methods: {
        addElement() {
            if (this.elements.length >= this.maxItems) {
                return;
            }
            this.elements.push({ title: "" });
        },
        removeElement(index) {
            this.elements.splice(index, 1);
        },
        clearElements() {
            this.elements = [{ title: "" }];
        }
    }
};
</script>
